import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import ExplevelEditForm from './ExplevelEditForm';
import ExplevelList from './ExplevelList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import ExplevelListView from './ExplevelListView'


export default function ExplevelDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.manufslice.explevelDashboard);
  const [ explevelId, setExplevelId] = React.useState('');
  const [reloadExplevelList, setReloadExplevelList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <ExplevelEditForm 
            setReloadExplevelList={setReloadExplevelList}
            explevelId={explevelId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <ExplevelListView 
                      setExplevelId = {setExplevelId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
